<wr-base-dialog [submitResponse]="submitControlSystem.bind(this)" status="primary" header="Messstation verknüpfen">
  <form *ngIf="form" [formGroup]="form">
    <div class="item">
      <div class="row">
        <div class="col">
          <label class="label" for="street">Messstation</label>
          <wr-control-system-select formControlName="controlSystem"></wr-control-system-select>
          <div class="error" *ngIf="hasError('controlSystem')">Messstation is erforderlich!</div>
        </div>
      </div>
    </div>
  </form>
</wr-base-dialog>
